import React from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import { contactsInGroupSelector } from '../../selectors'
import Panels from 'components/ContactsPage/Panels'

const mapStateToProps = (state) => {
	return {
		contactsInGroup: contactsInGroupSelector(state),
	}
}

const styles = (theme) => ({
	heightClass: {
		height: 'calc(100vh - 274px)',
		[theme.breakpoints.down('xs')]: {
			height: 'calc(100vh - 158px)',
		},
	},
})

const ContactPanels = ({ contactsInGroup, classes, groupID }) =>
	Object.keys(contactsInGroup).length ? (
		<Panels
			groupID={groupID}
			heightClass={classes.heightClass}
			contacts={Object.values(contactsInGroup)}
		/>
	) : null

export default connect(mapStateToProps, null)(withStyles(styles)(ContactPanels))
